import { useQuery } from "@tanstack/react-query"

import { HealthService } from "api"

// healthcheck doesn't require authentication so the query is always enabled.
export const useHealthcheck = () => useQuery(["healthcheck"], HealthService.healthGet, { enabled: true })
